import { highlights, siteStats } from "@/mocks/siteContent";
import SectionHeading from "./SectionHeading";

export default function HighlightsSection() {
  return (
    <section id="about" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="本站速览"
          title="一个页面，帮你把伦理片的选择理清楚"
          desc="不堆砌片单，也不写空话。我们把选片需要的四件事分摊到页面里：题材分类、字幕画质说明、榜单趋势与编辑手记，让每一位观众都能在几分钟内找到方向。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {highlights.map((item) => (
            <article key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>

        <dl className="mt-8 grid grid-cols-2 gap-4 rounded-lg border border-background-200 bg-background-50 p-6 md:grid-cols-4 md:p-8">
          {siteStats.map((stat) => (
            <div key={stat.label} className="text-center md:text-left">
              <dt className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500">{stat.label}</dt>
              <dd className="mt-2 font-heading text-2xl text-primary-700 md:text-3xl">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}